export default __webpack_public_path__ + "static/media/car-7.1feca5dd.png";